/** See `src/i18n/locales/en/editions.ts`. */
export const editions = {
  fit: {
    sections: {
      home: 'Start',
      insights: 'Einblicke',
      programs: 'Programme',
      content: 'Inhalte',
    },
    items: {
      overview: 'Übersicht',
      departments: 'Abteilungen',
      users: 'Benutzer',
      vitality: 'Vitalität',
      participation: 'Teilnahme',
      pilots: 'Piloten',
      challenges: 'Challenges',
      communications: 'Kommunikation',
      documents: 'Dokumente',
      reports: 'Berichte',
      settings: 'Einstellungen',
    },
  },
  soccer: {
    sections: {
      home: 'Start',
      insights: 'Einblicke',
      programs: 'Programme',
    },
    items: {
      overview: 'Übersicht',
      departments: 'Teams',
      users: 'Spieler',
      vitality: 'Vitalität',
      participation: 'Teilnahme',
      pilots: 'Piloten',
      challenges: 'Challenges',
    },
  },
} as const;
